import React from "react";
import { Check, Minus, CircleDot } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

const Cell = ({ v, a11y }) => {
  if (v === 2) return <Check size={17} strokeWidth={2.4} className="text-[#19C7C1] mx-auto" aria-label={a11y.yes} />;
  if (v === 1) return <CircleDot size={15} className="text-slate-400 mx-auto" aria-label={a11y.partial} />;
  return <Minus size={15} className="text-slate-300 mx-auto" aria-label={a11y.no} />;
};

export const Comparison = () => {
  const { t } = useLang();
  return (
    <section className="bg-white py-28 md:py-36 border-t border-black/5" data-testid="home-comparison">
      <div className="max-w-[1100px] mx-auto px-6 md:px-10">
        <Reveal className="text-left mb-14">
          <p className="eyebrow-dark">{t.comparison.eyebrow}</p>
          <h2 className="mt-5 text-3xl md:text-4xl font-light tracking-tight text-[#061A26]">{t.comparison.title}</h2>
          <p className="mt-4 text-base text-slate-600 max-w-xl">{t.comparison.copy}</p>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="overflow-x-auto border border-black/8">
            <table className="w-full text-sm min-w-[640px]" data-testid="comparison-table">
              <thead>
                <tr className="border-b border-black/8">
                  <th className="text-left p-5 font-medium text-slate-500 text-xs tracking-widest uppercase w-[36%]"></th>
                  {t.comparison.formats.map((f, i) => (
                    <th key={f} className={`p-5 text-center font-semibold ${i === 0 ? "bg-[#061A26] text-[#19C7C1]" : "text-[#061A26]"}`}>
                      {f}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {t.comparison.rows.map((row) => (
                  <tr key={row.label} className="border-b border-black/5 last:border-0 hover:bg-[#DFF7F5]/20 transition-colors duration-300">
                    <td className="p-5 text-[#061A26] font-medium">{row.label}</td>
                    {row.values.map((v, i) => (
                      <td key={i} className={`p-5 text-center ${i === 0 ? "bg-[#061A26]/[0.03]" : ""}`}>
                        <Cell v={v} a11y={t.a11y} />
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-5 text-xs text-slate-500 leading-relaxed" data-testid="comparison-note">{t.comparison.note}</p>
        </Reveal>
      </div>
    </section>
  );
};
